module.exports = __webpack_public_path__ + "img/netcat.f1195c6b.png";